import { apiClient } from './client';

export interface PillarDto {
  pillarId: number;
  pillarName: string;
  colorCode: string;
  isActive: boolean;
  createdBy?: number;
  createdOn?: string;
  modifiedBy?: number;
  modifiedOn?: string;
}

export const pillarsApi = {
  list(): Promise<PillarDto[]> {
    return apiClient.get<PillarDto[]>('/api/pillars');
  },

  getById(id: number): Promise<PillarDto> {
    return apiClient.get<PillarDto>(`/api/pillars/${id}`);
  },
};
